module.exports = __webpack_public_path__ + "static/media/display.188376f2.jpg";